document.addEventListener('DOMContentLoaded', () => {

  // 1. NAV SCROLL BEHAVIOR
  const nav = document.querySelector('.site-nav')
  if (nav) {
    const onScroll = () => nav.classList.toggle('is-scrolled', window.scrollY > 40)
    window.addEventListener('scroll', onScroll, { passive: true })
    onScroll()
  }

  // 2. MOBILE MENU
  const toggle = document.querySelector('.mobile-toggle')
  const menu = document.querySelector('.mobile-menu')
  const close = document.querySelector('.mobile-menu__close')

  if (menu) {
    const openMenu = () => {
      menu.classList.add('is-open')
      menu.setAttribute('aria-hidden', 'false')
      toggle?.setAttribute('aria-expanded', 'true')
      document.body.style.overflow = 'hidden'
    }
    const closeMenu = () => {
      menu.classList.remove('is-open')
      menu.setAttribute('aria-hidden', 'true')
      toggle?.setAttribute('aria-expanded', 'false')
      document.body.style.overflow = ''
    }

    toggle?.addEventListener('click', openMenu)
    close?.addEventListener('click', closeMenu)
    menu.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMenu))
  }

  // 3. FAQ ACCORDION
  document.querySelectorAll('.faq__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.faq__item')
      const body = item.querySelector('.faq__body')
      const expanded = trigger.getAttribute('aria-expanded') === 'true'

      // close all others
      document.querySelectorAll('.faq__item').forEach(i => {
        i.querySelector('.faq__trigger').setAttribute('aria-expanded', 'false')
        i.querySelector('.faq__body').classList.remove('is-open')
      })

      if (!expanded) {
        trigger.setAttribute('aria-expanded', 'true')
        body.classList.add('is-open')
      }
    })
  })

  // open first by default
  const firstFaq = document.querySelector('.faq__trigger')
  if (firstFaq) {
    firstFaq.setAttribute('aria-expanded', 'true')
    firstFaq.closest('.faq__item').querySelector('.faq__body').classList.add('is-open')
  }

  // 4. SCROLL REVEAL
  const ro = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible')
        ro.unobserve(e.target)
      }
    })
  }, { threshold: 0.12 })

  document.querySelectorAll('.reveal').forEach(el => ro.observe(el))

  // 5. SMOOTH SCROLL for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const target = document.querySelector(a.getAttribute('href'))
      if (target) {
        e.preventDefault()
        target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    })
  })

  // 6. CONTACT FORM — loading state only, Shopify handles POST natively
  document.querySelector('.contact-form')?.addEventListener('submit', e => {
    const btn = e.target.querySelector('.form-submit')
    if (btn) { btn.textContent = 'Bezig…'; btn.disabled = true }
  })

})
